import { render, staticRenderFns } from "./PlanNameAndSuggestionsPage.vue?vue&type=template&id=644cb4b1&scoped=true"
import script from "./PlanNameAndSuggestionsPage.vue?vue&type=script&lang=js"
export * from "./PlanNameAndSuggestionsPage.vue?vue&type=script&lang=js"
import style0 from "./PlanNameAndSuggestionsPage.vue?vue&type=style&index=0&id=644cb4b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644cb4b1",
  null
  
)

export default component.exports